import { addExpenseApi } from "_services";
import { updateCharOfAccountCategory } from "_services/accountingServices/accountingServices";
import { CommonInput, CommonModal, CustomSelect } from "components";
import { constant } from 'constants/constant';
import { errorSchema, utils } from "helper";
import React, { useEffect, useState } from "react";
import { StorageServices } from "utils";

const AddTypeOfCategory = (props) => {
    const { closeModal, isOpen, callbackHnadle, currentMenuData } = props;

    const initial = {
        name: "",
        calculation_type: 1,
    };

    const [form, setForm] = useState(initial);
    const [formError, setFormError] = useState({});
    const [isloading, setIsloading] = useState(false)

    console.log(currentMenuData)

    const handleOnChange = (name, value) => {
        setForm(prev => ({
            ...prev,
            [name]: value
        }));

        // Clear error for this field
        if (formError[name]) {
            setFormError(prev => ({
                ...prev,
                [name]: ""
            }));
        }
    };

    const handleInputChange = async (name, value) => {
        const stateObj = {
            ...form,
            [name]: value,
        };

        setForm(stateObj);

        if (!!formError) {
            const validationResult = await utils.checkFormError(
                { ...stateObj },
                errorSchema.addCategoryType
            );
            if (validationResult === true) {
                setFormError("");
            } else {
                setFormError(validationResult);
            }
        }
    }

    const handleSubmit = async () => {

        const payload = {
            ...form
        }

        const validationResult = await utils.checkFormError(
            { ...form },
            errorSchema.addCategoryType
        );

        if (validationResult == true) {
            setIsloading(true)
            try {
                const res = isOpen?._id ? await updateCharOfAccountCategory({ ...payload, account_id: isOpen?._id })
                    : await addExpenseApi({
                        ...payload, category_id: currentMenuData?.categoryId,
                        sub_category_id: currentMenuData?.subCategoryId, company_id: StorageServices?.getCompanyId()
                    })

                if (res?.responseCode == 200) {
                    callbackHnadle()
                }
            } catch (error) {

            } finally {
                setIsloading(false)
            }
        }

        setFormError(validationResult)
    };

    const modalProps = {
        ...props,
        onSubmit: handleSubmit,
        isLoadding: isloading,
        disabled:isOpen?.type=="show"
    };


    useEffect(() => {

        if (isOpen?._id) {
            setForm((pre) => ({ ...pre, name: isOpen?.name, calculation_type: isOpen?.calculation_type }))
        } else {
            setForm((pre) => ({ ...pre, name: "", calculation_type: 1 }))
        }
        setFormError("");
    }, [isOpen?._id])

    return (
        <CommonModal {...modalProps}>
            <div className="addExpense_modal_body" style={{ padding: '20px' }}>
                {/* Expense Category Dropdown */}


                {/* Goods/Services Radio Buttons */}
                <div className="checkBx_lv" style={{ marginBottom: '30px' }}>
                    {constant.TypeOfCategoryRadio?.map((item, index) => (
                        <div className="_dualCheckr_bx" key={index} style={{ maxWidth: '140px', width: '100%' }}>
                            <input
                                style={{ marginTop: '2px' }}
                                className="form-check-input"
                                id={`calculation_type_${item?.value}`}
                                type="radio"
                                name="calculation_type"
                                checked={form.calculation_type === item?.value}
                                value={item?.value}
                                onChange={({ target: { value } }) => handleOnChange("calculation_type", Number(value))}
                                disabled={isOpen?.type=="show"}
                            />
                            <label
                                style={{ fontSize: '14px' }}
                                htmlFor={`calculation_type_${item?.value}`}
                                className="form-check-label"
                            >
                                {item.label}
                            </label>
                        </div>
                    ))}
                </div>
                <div>
                    <CommonInput
                        type="text"
                        placeholder="Category Name"
                        label="Category"
                        name='name'
                        value={form?.name}
                        onChange={(e) => handleInputChange('name', e.target.value)}
                        maxLength={100}
                        error={formError.name}
                        focus={formError.name}
                        disabled={isOpen?.type=="show"}
                    />
                </div>


            </div>
        </CommonModal>
    );
};

export default AddTypeOfCategory;